import { render, staticRenderFns } from "./host-home.vue?vue&type=template&id=224aec01&scoped=true&"
import script from "./host-home.vue?vue&type=script&lang=js&"
export * from "./host-home.vue?vue&type=script&lang=js&"
import style0 from "./host-home.vue?vue&type=style&index=0&id=224aec01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224aec01",
  null
  
)

export default component.exports